import SampleReportView from "@/components/samples/SampleReportView";
import { PARADISE_ENERGY_SOLUTIONS_REPORT } from "@/data/sample-reports";

const ParadiseEnergySolutionsSample = () => <SampleReportView report={PARADISE_ENERGY_SOLUTIONS_REPORT} />;

export default ParadiseEnergySolutionsSample;
